import React from 'react';
import SMOSpaceEditBaseFragment from './SMOSpaceEditBaseFragment';
import SMFormTextAreaWithError from 'components/dashboard/form/SMFormTextAreaWithError';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMConst from 'lib/SMConst';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMOAcademyLinkBaloonView from 'components/dashboard/owners/SMOAcademyLinkBaloonView';

class SMOSpaceEditTermsFragment extends SMOSpaceEditBaseFragment {
  
  constructor(props) {
    super(props);
    this.state = {
      space: this.props.space,
      isCurrent : this.isCurrent(this.props),
      errors: this.props.errors,
    };
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      isCurrent : this.isCurrent(nextProps),
      space : nextProps.space,
    });
  }
  
  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }
  
  actionButtonDidClick(status, label, e) {
    this.trackPageEvent(label);

    if(this.props.delegate && typeof this.props.delegate.actionButtonDidClick === 'function') {
      this.props.delegate.actionButtonDidClick(status, e);
    }
  }

  renderActionButtons() {
    if (!this.props.space.can_display) {
      return(
        <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
          <a href={Routes.owner_dashboard_spaces_path(this.props.owner.username)} onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Visible, 'od temporarily_save space_1')}
            className='button button-gray maincol-buttonarea__button'>終了</a>
        </div>
      );
    }
    
    const hasRooms = (this.props.space.rooms && this.props.space.rooms.length > 0);

    if (this.props.owner.status == SMConst.OwnerStatus.Created) {
      if (hasRooms) {
        return(
          <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
            <a href={Routes.owner_dashboard_space_path(this.props.owner.username, this.props.space.username)} onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Visible, 'od temporarily_save space_1')} className='button button-gray maincol-buttonarea__button'>終了</a>
          </div>
        );
      } else {
        return(
          <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
            <a href={Routes.owner_dashboard_space_path(this.props.owner.username, this.props.space.username)} onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Visible, 'od temporarily_save space_1')}
              className='button button-gray maincol-buttonarea__button'>終了</a>
            <a href={Routes.new_owner_dashboard_space_room_path(this.props.owner.username, this.props.space.username)} onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Visible, 'od add room')}
              className='button button-green maincol-buttonarea__button'>スペースの登録へ</a>
          </div>
        );
      }
    } else {
      if (hasRooms) {
        return(
          <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
            <a href={Routes.owner_dashboard_spaces_path(this.props.owner.username)} onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Visible, 'od save visible_space_1')}
              className='button button-green maincol-buttonarea__button'>公開して終了</a>
          </div>
        );
      } else {
        return(
          <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
            <a href={Routes.new_owner_dashboard_space_room_path(this.props.owner.username, this.props.space.username)} onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Visible, 'od add room')}
              className='button button-green maincol-buttonarea__button'>スペースの登録へ</a>
          </div>
        );
      }
    }
  }
  
  render() {
    return (
      <div ref="fragment" style={this.fragmentStyle()}>
        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__optional">任意</span>キャンセルポリシー
          <span className="dashboard-title__supplement ml15">
            未入力の場合は、スペースマーケットの<a href={Routes.cancel_policy_about_index_path()} target="_blank">標準キャンセルポリシー</a>に準ずる旨を表示します。
          </span>
        </h2>
        <SMFormTextAreaWithError name="policy"
          value={this.state.space.policy}
          options={{className: 'form-textarea w700 h80',}}
          errorText={SMFormatHelper.errorText('Space', 'policy', this.props.errors)}
          placeholderText="スペースマーケットの標準キャンセルポリシーに準ずる"
          delegate={this} />

        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__optional">任意</span>利用規約
          <span className="dashboard-title__supplement ml15">
            未入力の場合は、スペースマーケットの<a href={Routes.terms_of_space_use_about_index_path()} target="_blank">ゲスト規約</a>に準ずる旨を表示します。
          </span>
        </h2>
        <SMFormTextAreaWithError name="terms"
          value={this.state.space.terms}
          options={{className: 'form-textarea w700 h80',}}
          errorText={SMFormatHelper.errorText('Space', 'terms', this.props.errors)}
          placeholderText="スペースマーケットのゲスト規約に準ずる"
          delegate={this} />

        {this.renderActionButtons()}

        <SMOAcademyLinkBaloonView displayPlace={SMConst.AcademyLinkDisplayPlace.SpaceTerms} isCurrent={this.state.isCurrent} />
      </div>
    );
  }
}
SMOSpaceEditTermsFragment.defaultProps = {
  errors: [],
};
export default SMOSpaceEditTermsFragment;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/spaces/fragments/SMOSpaceEditTermsFragment.jsx